import React, { useEffect, useState, useRef } from 'react';
import $ from 'jquery';
import { GetCoockie, ValidateQty, FormatCurrency, DefaultImage, KImageURL, SearchContent, CheckSession, PrintDocument } from "../GlobalScript";
import Modal from 'react-bootstrap/Modal';
import CloseButton from 'react-bootstrap/CloseButton';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import { useReactToPrint } from 'react-to-print';

const HistoryDetail = ({ show, handleClose, order, historyType, userInfo }) => {

    const [isPrinting, setIsPrinting] = useState(false);
    const contentRef = useRef(null);
    const promiseResolveRef = useRef(null);
    const [CreditRequest, setCreditRequest] = useState(false);
    //const [CRDocument, setCRDocument] = useState(null);

    useEffect(() => {
        if (isPrinting && promiseResolveRef.current) {
            promiseResolveRef.current();
        }
    }, [isPrinting]);

    useEffect(() => {
        if (historyType === 'credit' && order && order.orderDetail) {
            const map = new Map();
            order.orderDetail.items.forEach((data) => {
                const groupKey = data.invoice;
                if (map.has(groupKey)) {
                    const temp = map.get(groupKey);
                    temp.set(data.sku, data);
                } else {
                    const temp = new Map();
                    temp.set(data.sku, data);
                    map.set(groupKey, temp)
                }
            });
            setCreditRequest(map);
        }
    }, [order]);

    //const handlePrint = useReactToPrint({
    //    contentRef,
    //    onBeforeGetContent: () => {
    //        return new Promise((resolve) => {
    //            promiseResolveRef.current = resolve;
    //            setIsPrinting(true);
    //        });
    //    },
    //    onAfterPrint: () => {
    //        promiseResolveRef.current = null;
    //        setIsPrinting(false);
    //    }
    //});

    const handlePrint = (crNum) => {
        if (crNum) {
            PrintDocument(crNum);
        }
    }    

    const AddressBlock = (data) => {
        return <>
            <p className="mb-0">{data.firstName}</p>
            <p className="mb-0">{data.address} {data.city}</p>
            <p className="mb-0">{data.stateCode} {data.zipCode}</p>
            <p className="mb-0">{data.countryCode}</p></>
    }

    if (!order) return null;

    return (
        <Modal show={show} onHide={handleClose} scrollable size="lg" dialogClassName="modal-90w dealer-section item-inquiry-modal">
            <style type="text/css" media="print">
                {"\
                @page { size: landscape; }\
                "}
            </style>
            <Modal.Header closeButton>
                <Row className="w-100w">
                    <Col sm={12}>
                        <Modal.Title className="text-left">{historyType === 'order' ? 'ORDER DETAIL' : 'CREDIT REQUEST DETAILS'}</Modal.Title>
                    </Col>
                </Row>
                <CloseButton variant="white" data-bs-theme="dark" />
            </Modal.Header>

            <Modal.Body ref={contentRef}>
                <Row>
                    <Col sm={12}>
                        <Card>
                            <Card.Body>
                                <Row>
                                    {order && order.order && order.orderDetail &&
                                        <>
                                            <Col sm={3} className="text-left">
                                                <p className="bold">Order Information</p>

                                                {/*<p className="mb-0">Reference #: {order.order.refID}</p>*/}
                                                {historyType === 'order' ?
                                                    <>
                                                        {order.order.orderID && <p className="mb-0">Order #: {order.order.orderID}</p>}
                                                        {order.order.orderName && <p className="mb-0">Order Name: {order.order.orderName}</p>}
                                                        <p className="mb-0">Order Date: {order.order.orderDate}</p>
                                                        <p className="mb-0">Order Type: {order.orderDetail.orderType}</p>
                                                    <p className="mb-0">Ordered By: {order.order.orderByName}</p>
                                                    {
                                                        order.order.dealer === true &&
                                                        <><p className="mb-0">KCode: {order.orderDetail.kCode}</p>
                                                            <p className="mb-0">Exchange Order: {order.orderDetail.exchangeOrder ? 'Yes' : 'No'}</p></>
                                                    }
                                                    
                                                    </>
                                                    :
                                                    <>
                                                        {order.order.orderID && <p className="mb-0">Confirmation #: {order.order.orderID}</p>}
                                                        <p className="mb-0">Request Date: {order.order.orderDate}</p>
                                                        <p className="mb-0">Requested By: {order.order.orderByName}</p>
                                                    </>
                                                }
                                            </Col>
                                        
                                            <Col sm={3} className="text-left">
                                            <p className="bold">{historyType === 'order' ? 'Shipping Information' : 'Dealer Information'}</p>
                                            {order.orderDetail.shipTo && order.orderDetail.shipTo.countryCode === '' && <p className="mb-0 bold">Dropship Address:</p>}
                                            {order.orderDetail.shipTo && AddressBlock(order.orderDetail.shipTo)}
                                                {order.orderDetail.forwarderTo && <p className="mb-0 mt-2 bold">Forwarder Address:</p>}
                                                {order.orderDetail.forwarderTo &&
                                                    AddressBlock(order.orderDetail.forwarderTo)
                                                }
                                            </Col>

                                            {historyType === 'order' &&
                                                <Col sm={3} className="text-left">
                                                    <>
                                                        <p className="bold">Shipping Method</p>
                                                        <p className="mb-0">{order.orderDetail.shipMethod}</p>
                                                    </>
                                                </Col>
                                            }

                                            {historyType === 'credit' && order.order.orderID && order.order.status === "Submitted" && 
                                                <Col sm={3} className="text-left">
                                                    <p className="bold underline" id="btnPrint" onClick={()=>handlePrint(order.order.orderID)}>
                                                        <span className="svg-holder small-svg" style={{ display: 'flex' }}>
                                                            <img src="../../../Images/printer-icon.svg" alt="Print" style={{ height: '40px', marginTop: '-8px' }} />
                                                            Print Documents
                                                        </span>
                                                    </p>
                                                </Col>
                                            }

                                        </>
                                    }
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12} className="order-table">
                        <Card>
                            <Card.Body>
                                <Row className="table-legend">
                                    <Col sm={12}>
                                        <div className="table-legend-section">
                                            <span className="svg-holder"><img src="../../../Images/parts.svg" alt="" className="" /> Parts</span>
                                            <span className="svg-holder"><img src="../../../Images/accessories.svg" alt="" className="" /> Accessories</span>
                                            <span className="svg-holder"><img src="../../../Images/other.svg" alt="" className="" /> Other</span>
                                        </div>
                                        <div className="table-legend-section">
                                            {userInfo?.loginType === 5 &&
                                                <>
                                                    <span className="svg-holder"><img src="../../../Images/Allocated.svg" alt="" className="" />Allocated</span>
                                                    <span className="svg-holder"><img src="../../../Images/AllocationProcessing.svg" alt="" className="" />Allocation Processing</span>
                                                </>
                                            }
                                            <span className="svg-holder"><img src="../../../Images/partially-shipped.svg" alt="" className="" /> Partially Shipped</span>
                                            <span className="svg-holder"><img src="../../../Images/shipped-active.svg" alt="" className="" /> Shipped</span>
                                            {userInfo?.loginType !== 5 &&
                                                <span className="svg-holder"><img src="../../../Images/returned.svg" alt="" className="" /> Returned</span>
                                            }
                                            <span className="svg-holder"><img src="../../../Images/queued.svg" alt="" className="" /> Queued</span>
                                            <span className="svg-holder"><img src="../../../Images/cancelled-inactive.svg" alt="" className="" /> Cancelled</span>
                                        </div>
                                        <div className="table-legend-section">
                                            <span className="svg-holder"><img src="../../../Images/backorder.svg" alt="" className="" /> Backorder</span>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>

                        <Table hover responsive className="compact-table">
                            {historyType === 'order' &&
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        {/*<th>PRODUCT <br /> IMAGE</th>*/}
                                        <th width={"32%"}>PRODUCT</th>
                                        <th>MEMO</th>
                                        <th width={"5%"}>ITEM <br /> TYPE</th>
                                        <th width={"5%"}>STATUS</th>
                                        <th>QTY</th>
                                        <th>BKORD <br /> QTY</th>
                                        <th>UNIT <br /> PRICE</th>
                                        <th>SUBTOTAL</th>
                                    </tr>
                                </thead>
                            }

                            {historyType === 'order' && order && order.orderDetail && order.orderDetail.items && order.orderDetail.items.map((item, index) => (
                                    <tbody>
                                        <tr className="" key={index}>
                                            <td>{index + 1}</td>
                                            {/*<td className="table-img">*/}
                                            {/*    <img src={KImageURL(item.sku, item.img)}*/}
                                            {/*        onError={({ currentTarget }) => {*/}
                                            {/*            currentTarget.onerror = null;*/}
                                            {/*            currentTarget.src = DefaultImage;*/}
                                            {/*        }}*/}
                                            {/*        alt="Product" className="item-image"></img>*/}
                                            {/*</td>*/}
                                            <td className="table-left">
                                                <p className="mb-0">{item.desc}</p>
                                                <p className="mb-0">Item No: {item.sku}</p>
                                            </td>
                                            <td>{item.memo}</td>
                                            <td className="table-img">
                                                <img src={"../../../Images/" + item.inventoryTypeImg} alt="item-type" className="item-type-image"></img>
                                            </td>
                                            <td className="table-img"> <span className="svg-holder"><img src={"../../../Images/" + item.statusImg} alt="" className="item-type-image" /></span></td>
                                            <td>{item.qty}</td>
                                            <td>{item.boQty}</td>
                                            <td>${item.unitPrice}</td>
                                            <td>${item.subtotal}</td>
                                        </tr>
                                    </tbody>
                                ))
                            }

                            {historyType === 'credit' && CreditRequest && CreditRequest.size > 0 &&
                                <Row>
                                    {Array.from(CreditRequest.entries()).map(([key, valueArray]) => (
                                        <React.Fragment key={key}>
                                            {key && SearchContent(key)}
                                            <Col sm={12} className="order-table" key={"col2_" + key}>
                                                <Table hover responsive key={"tbl" + key} className="compact-table">
                                                    <thead>
                                                        <tr>
                                                            {/*<th>IMAGE</th>*/}
                                                            <th width="15%">DETAILS</th>
                                                            <th>RETURN <br /> QTY</th>
                                                            <th>Received <br /> QTY</th>
                                                            <th>PRICE</th>
                                                            <th width="25%">REASON AND <br /> COMMENT</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Array.from(valueArray.values()).map((value, index) => (
                                                            <tr className="" key={key + value.sku}>
                                                                {/*<td className="table-img">*/}
                                                                {/*    <img src={KImageURL(value.sku, value.img)}*/}
                                                                {/*        onError={({ currentTarget }) => {*/}
                                                                {/*            currentTarget.onerror = null;*/}
                                                                {/*            currentTarget.src = DefaultImage;*/}
                                                                {/*        }}*/}
                                                                {/*        alt="Product"*/}
                                                                {/*        className="item-image">*/}
                                                                {/*    </img>*/}
                                                                {/*</td>*/}
                                                                <td className="text-left">
                                                                    {/*{value.invoice && <p className="green-text">Invoice: #{value.invoice}</p>}*/}
                                                                    <p>{value.desc}</p>
                                                                    <p className="mb-0">SKU: {value.sku}</p>
                                                                </td>
                                                                <td>{value.return_qty}</td>
                                                                <td>{value.received_qty}</td>
                                                                <td>${FormatCurrency(value.unitPrice)}</td>
                                                                <td>
                                                                    <p>{value.returnReason}</p>
                                                                    <p>{value.comments}</p>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </React.Fragment>
                                    ))}
                                </Row>
                            }
                        </Table>
                    </Col>

                    {historyType === 'order' ?
                        order && order.orderDetail && <>
                            <Col xl={{ offset: 8 }} className="vertical-line mb-4 padding-extra-right text-right">
                                <Row>
                                    <Col className="text-left">
                                        <p className="mb-0">Parts Subtotal</p>
                                        <p className="mb-0">Acc Subtotal</p>
                                        <p className="mb-0">Other Subtotal</p>
                                        <p className="mb-0">Est Freight</p>
                                        <p className="mb-0">Est Handling</p>
                                        <p className="mb-0">Est Special Fee</p>
                                        <p className="mb-0">K-Code</p>
                                        <p className="mb-0 bold">Total</p>
                                    </Col>
                                    <Col className="text-right">
                                        <p className="mb-0">${order.orderDetail.partsSubtotal}</p>
                                        <p className="mb-0">${order.orderDetail.accSubtotal}</p>
                                        <p className="mb-0">${order.orderDetail.otherSubtotal}</p>
                                        <p className="mb-0">${order.orderDetail.estFreight}</p>
                                        <p className="mb-0">${order.orderDetail.estHandling}</p>
                                        <p className="mb-0">${order.orderDetail.estSpecialFee}</p>
                                        <p className="mb-0">{order.orderDetail.kCode ? order.orderDetail.kCode : "N/A"}</p>
                                        <p className="mb-0 bold">{FormatCurrency(order.order.total)}</p>
                                    </Col>
                                </Row>
                            </Col>
                        </>

                        :
                        <>
                            {order && order.order &&
                                <Col sm={{ offset: 9 }} className="vertical-line mb-4">
                                    <Row>
                                        <Col className="text-left">
                                            <p className="mb-0">Credit Subtotal</p>
                                            <p className="mb-0 bold">Total</p>
                                        </Col>
                                        <Col>
                                            <p className="mb-0">${order.order.total}</p>
                                            <p className="mb-0 bold">${order.order.total}</p>
                                        </Col>
                                    </Row>
                                </Col>}
                        </>
                    }
                </Row>

                {historyType === 'order' &&
                    <Row>
                        <Col sm={12} className="order-table">
                            <div className="vertical-line text-left mt-2">
                                <h4 className="bold">TRACKING</h4>
                            </div>

                            <Card>
                                <Card.Body>
                                    <Row className="table-legend">
                                        <Col sm={12}>
                                            <div className="table-legend-section">
                                                <span className="svg-holder"><img src="../../../Images/partially-shipped.svg" alt="" className="" /> Partially Shipped</span>
                                                <span className="svg-holder"><img src="../../../Images/shipped-active.svg" alt="" className="" /> Shipped</span>
                                                <span className="svg-holder"><img src="../../../Images/returned.svg" alt="" className="" /> Returned</span>
                                                <span className="svg-holder"><img src="../../../Images/queued.svg" alt="" className="" /> Queued</span>
                                                <span className="svg-holder"><img src="../../../Images/cancelled-inactive.svg" alt="" className="" /> Cancelled</span>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>

                            <Table hover responsive className="mb-5 compact-table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>PRODUCT</th>
                                        <th>STATUS</th>
                                        <th>QTY <br /> ORDERED</th>
                                        <th>QTY <br /> SHIPPED</th>
                                        <th>QTY <br /> CANCELLED</th>
                                        <th>QTY <br /> RETURNED</th>
                                        <th>QTY <br /> OWED</th>
                                        <th>INVOICE</th>
                                        <th>CARRIER</th>
                                        <th>TRACKING</th>
                                        <th>DATE <br /> SHIPPED</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {order && order.orderDetail && order.orderDetail.trackings && order.orderDetail.trackings.map((item, index) => (
                                        <tr className="" key={"tr" + index}>
                                            <td>{index + 1}</td>
                                            <td className="table-left">
                                                <p className="mb-0">{item.desc}</p>
                                                <p className="mb-0">Item No: {item.sku}</p>
                                            </td>
                                            <td></td>
                                            {/* <td>Icon</td>*/}
                                            <td>{item.qtyOrdered}</td>
                                            <td>{item.qtyShipped}</td>
                                            {/*<td>{item.qtyCancelled}</td>*/}
                                            <td></td>
                                            <td>{item.qtyReturned}</td>

                                            <td></td>
                                            {/*  <td>{item.qtyOwned}</td>*/}
                                            <td>{item.invoice}</td>
                                            <td>{item.carrier}</td>
                                            <td>
                                                {item.carrier === "UPS"? <a href={item.url} target="_blank" rel="noopener noreferrer">
                                                    {item.tracking}
                                                </a> : <>{item.tracking}</>}
                                             
                                            </td>
                                          
                                            <td>{item.dateShipped}</td>
                                        </tr>
                                    ))}

                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                }
            </Modal.Body>

            <Modal.Footer className="black-bg">
                <Row className="w-100w">
                    <Col sm={{ offset: 10 }}>
                        <Button variant="secondary" onClick={handleClose}>
                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                            </svg>
                            CLOSE
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>

        </Modal>
    )
}

export default HistoryDetail;